<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@cheapestFareFinder" id="modal-header">Cheapest Fare Finder</h3>
    <button
      type="button"
      class="close"
      aria-label="Close Cheapest Fare Finder"
      (click)="activeModal.close()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <ng-container>
      <div id="class_Dropdown" class="dropdown_wrapper">
        <label i18n="@@cffClass">Class:</label>
        <select
          [(ngModel)]="selectedClass"
          (ngModelChange)="resetSelected()"
          appSelect
          [border]="true"
          [noIcon]="true"
        >
          @if (displayStandard && displayFirst) {
            <option [value]="classSelectors.cheapest" i18n="@@cffAny">Any</option>
          }
          @if (displayStandard) {
            <option [value]="classSelectors.cheapestStandard" i18n="@@cffStandard">Standard</option>
          }
          @if (displayFirst) {
            <option [value]="classSelectors.cheapestClass" i18n="@@cffFirstClass">
              First Class
            </option>
          }
        </select>
      </div>
      <div>
        @if (!searchParams.originalUserSearch?.isAirportExpress) {
          <h4 class="search_results_page_title margin-bottom-20">
            <span i18n="@@railTrainsFor" id="cheapFare_SearchSummary">Trains for</span>
            {{ searchParams.originalUserSearch?.travellingFrom?.name | titlecase }}
            <i class="ico-breadcrumb-arrow" aria-hidden="true"></i>
            {{ searchParams.originalUserSearch?.travellingTo?.name | titlecase }}
            @if (searchParams.originalUserSearch?.viaLocation?.name) {
              <span
                >&nbsp;(Via
                {{ searchParams.originalUserSearch?.viaLocation?.name | titlecase }})</span
              >
            }
          </h4>
        }
      </div>
      <div class="flex-row-container flex-column-mobile">
        <div class="flex-column-container flex-grow table_container">
          <div class="flex-row-container flex-column-mobile">
            <span id="outbound_Date" class="outbound_selector">
              <i
                class="ico-chevron-left"
                (click)="prevDayOutbound()"
                role="button"
                tabindex="0"
                (keydown.enter)="prevDayOutbound()"
                aria-label="Outbound Previous Day"
              ></i>
              <span i18n="@@cffOutboundJourney">Outbound journey</span> -
              {{ outboundJourneys[0]?.departDateTime | sabsDate: 1 }}
              @if (canDisplayOutboundNextDay()) {
                <i
                  class="ico-chevron-right"
                  (click)="nextDayOutbound()"
                  role="button"
                  tabindex="0"
                  (keydown.enter)="nextDayOutbound()"
                  aria-label="Outbound Next Day"
                ></i>
              }
            </span>
            <table class="rail_results_table">
              @for (
                outboundJourney of outboundJourneys
                  | cheapestFareFinderOutbounds: resultMatrix : selectedClass;
                track outboundJourney;
                let first = $first;
                let last = $last
              ) {
                <tr>
                  <th
                    [ngClass]="{
                      selected_outbound:
                        outboundJourney.journeyHash === selectedOutbound?.journeyHash
                    }"
                  >
                    @if (first) {
                      <i
                        class="ico-chevron-up"
                        (click)="earlierOrLater(false, false)"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="earlierOrLater(false, false)"
                        aria-label="Outbound Earlier"
                      ></i>
                    }
                    <div>
                      {{ outboundJourney.from }}
                    </div>
                    <div>
                      {{ outboundJourney.departDateTime | sabsTimePipe }}
                    </div>
                    @if (last && canDisplayOutboundLater()) {
                      <i
                        class="ico-chevron-down"
                        (click)="earlierOrLater(false, true)"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="earlierOrLater(false, true)"
                        aria-label="Outbound Later"
                      ></i>
                    }
                  </th>
                  @for (
                    inboundJourney of inboundJourneys
                      | cheapestFareFinderInbounds: resultMatrix : selectedClass;
                    track inboundJourney
                  ) {
                    <ng-container>
                      <td
                        [ngClass]="{
                          selected_inbound:
                            inboundJourney.journeyHash === selectedInbound?.journeyHash,
                          selected_outbound:
                            outboundJourney.journeyHash === selectedOutbound?.journeyHash
                        }"
                      >
                        @if (
                          resultMatrix[outboundJourney.journeyHash][inboundJourney.journeyHash][
                            selectedClass
                          ]?.out?.identifiers?.isSplit ||
                          resultMatrix[outboundJourney.journeyHash][inboundJourney.journeyHash][
                            selectedClass
                          ]?.in?.identifiers?.isSplit
                        ) {
                          <section
                            class="flex-row-container flex-row-container--center split-ticket-container"
                          >
                            <app-split-ticket-icon></app-split-ticket-icon>
                          </section>
                        }
                        <div class="flex-row-container flex-row-container--center">
                          @if (
                            resultMatrix[outboundJourney.journeyHash][inboundJourney.journeyHash][
                              selectedClass
                            ]?.out &&
                            resultMatrix[outboundJourney.journeyHash][inboundJourney.journeyHash][
                              selectedClass
                            ]?.in
                          ) {
                            <section (mouseleave)="tt.close()" class="container">
                              <button
                                mat-button
                                color="accent"
                                [id]="
                                  'cheapFare_Ticket_Price_' +
                                  resultMatrix[outboundJourney.journeyHash][
                                    inboundJourney.journeyHash
                                  ][selectedClass]?.totalPrice
                                "
                                [ngbTooltip]="
                                  !resultMatrix[outboundJourney.journeyHash][
                                    inboundJourney.journeyHash
                                  ][selectedClass].out.selectable ||
                                  resultMatrix[outboundJourney.journeyHash][
                                    inboundJourney.journeyHash
                                  ][selectedClass].out.unavailable ||
                                  resultMatrix[outboundJourney.journeyHash][
                                    inboundJourney.journeyHash
                                  ][selectedClass].in.unavailable
                                    ? 'Unavailable'
                                    : null
                                "
                                triggers="manual"
                                #tt="ngbTooltip"
                                (focus)="tt.open()"
                                (blur)="tt.close()"
                                (mouseenter)="tt.open()"
                                (click)="
                                  selectedOutbound = outboundJourney;
                                  selectedInbound = inboundJourney
                                "
                                [ngClass]="{
                                  'selected-price':
                                    inboundJourney.journeyHash === selectedInbound?.journeyHash &&
                                    outboundJourney.journeyHash === selectedOutbound?.journeyHash,
                                  'disabled-price':
                                    !resultMatrix[outboundJourney.journeyHash][
                                      inboundJourney.journeyHash
                                    ][selectedClass].out.selectable ||
                                    resultMatrix[outboundJourney.journeyHash][
                                      inboundJourney.journeyHash
                                    ][selectedClass].out.unavailable ||
                                    resultMatrix[outboundJourney.journeyHash][
                                      inboundJourney.journeyHash
                                    ][selectedClass].in.unavailable
                                }"
                                [disabled]="
                                  !resultMatrix[outboundJourney.journeyHash][
                                    inboundJourney.journeyHash
                                  ][selectedClass].out.selectable ||
                                  resultMatrix[outboundJourney.journeyHash][
                                    inboundJourney.journeyHash
                                  ][selectedClass].out.unavailable ||
                                  resultMatrix[outboundJourney.journeyHash][
                                    inboundJourney.journeyHash
                                  ][selectedClass].in.unavailable
                                "
                              >
                                {{
                                  resultMatrix[outboundJourney.journeyHash][
                                    inboundJourney.journeyHash
                                  ][selectedClass]?.totalPrice
                                    | currency
                                      : resultMatrix[outboundJourney.journeyHash][
                                          inboundJourney.journeyHash
                                        ][selectedClass]?.out.currency
                                }}
                              </button>
                            </section>
                          }
                        </div>
                        @if (
                          resultMatrix[outboundJourney.journeyHash][inboundJourney.journeyHash][
                            selectedClass
                          ]?.out &&
                          resultMatrix[outboundJourney.journeyHash][inboundJourney.journeyHash][
                            selectedClass
                          ]?.in
                        ) {
                          <app-warning-tags
                            [iconId]="
                              resultMatrix[outboundJourney.journeyHash][inboundJourney.journeyHash][
                                selectedClass
                              ]?.out.fareHash
                            "
                            [ticket]="
                              resultMatrix[outboundJourney.journeyHash][inboundJourney.journeyHash][
                                selectedClass
                              ]?.out
                            "
                          ></app-warning-tags>
                          @if (
                            isGroupFare(
                              resultMatrix[outboundJourney.journeyHash][inboundJourney.journeyHash][
                                selectedClass
                              ]?.out
                            )
                          ) {
                            <section class="container">
                              @switch (sourceName) {
                                @case (ServiceProvider.Evolvi) {
                                  <div (mouseleave)="tt10.close()">
                                    <img
                                      src="https://images.sabscorp.com/images/GroupDiscount.gif"
                                      ngbTooltip="Group ticket - to qualify for this fare all travellers must travel together on the same ticket"
                                      alt="Group ticket"
                                      class="ico-float-left"
                                      tabindex="0"
                                      triggers="manual"
                                      #tt10="ngbTooltip"
                                      (mouseenter)="tt10.open()"
                                      (focus)="tt10.open()"
                                      (blur)="tt10.close()"
                                    />
                                  </div>
                                }
                                @case (ServiceProvider.Trainline) {
                                  <div (mouseleave)="tt10.close()">
                                    <span
                                      ngbTooltip="GroupSave discount applied. All passengers must travel together"
                                      class="ico-tl-group-save"
                                      triggers="manual"
                                      tabindex="0"
                                      #tt10="ngbTooltip"
                                      (mouseenter)="tt10.open()"
                                      (focus)="tt10.open()"
                                      (blur)="tt10.close()"
                                      >GroupSave</span
                                    >
                                  </div>
                                }
                              }
                            </section>
                          }
                        }
                      </td>
                    </ng-container>
                  }
                </tr>
              }
              <tr>
                <th></th>
                @for (
                  inboundJourney of inboundJourneys
                    | cheapestFareFinderInbounds: resultMatrix : selectedClass;
                  track inboundJourney;
                  let first = $first;
                  let last = $last
                ) {
                  <th
                    [ngClass]="{
                      selected_inbound: inboundJourney.journeyHash === selectedInbound?.journeyHash
                    }"
                  >
                    @if (first && canDisplayInboundEarlier()) {
                      <i
                        class="ico-chevron-left"
                        (click)="earlierOrLater(true, false)"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="earlierOrLater(true, false)"
                        aria-label="Inbound Earlier"
                      ></i>
                    }
                    <div>
                      {{ inboundJourney.from }}
                    </div>
                    <div>
                      {{ inboundJourney.departDateTime | sabsTimePipe }}
                    </div>
                    @if (last) {
                      <i
                        class="ico-chevron-right"
                        (click)="earlierOrLater(true, true)"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="earlierOrLater(true, true)"
                        aria-label="Inbound Later"
                      ></i>
                    }
                  </th>
                }
              </tr>
            </table>
          </div>
          <span id="inbound_Date" class="inbound_selector">
            @if (canDisplayInoundPreviousDay()) {
              <i
                class="ico-chevron-left"
                (click)="prevDayInbound()"
                role="button"
                tabindex="0"
                (keydown.enter)="prevDayInbound()"
                aria-label="Inbound Previous Day"
              ></i>
            }
            <span i18n="@@cffInboundJourney">Inbound journey</span> -
            {{ inboundJourneys[0]?.departDateTime | sabsDate: 1 }}
            <i
              class="ico-chevron-right"
              (click)="nextDayInbound()"
              role="button"
              tabindex="0"
              (keydown.enter)="nextDayInbound()"
              aria-label="Inbound Next Day"
            ></i>
          </span>
        </div>
        @if (selectedOutbound && selectedInbound) {
          <div class="flex-column-container flex-grow">
            <app-rail-basket-preview
              class="flex-grow"
              [outboundJourney]="selectedOutbound"
              [outboundFare]="
                resultMatrix[selectedOutbound.journeyHash][selectedInbound.journeyHash][
                  selectedClass
                ]?.out
              "
              [inboundJourney]="selectedInbound"
              [inboundFare]="
                resultMatrix[selectedOutbound.journeyHash][selectedInbound.journeyHash][
                  selectedClass
                ]?.in
              "
              [sourceId]="sourceId"
            ></app-rail-basket-preview>
            <div class="add_to_basket_container">
              <div
                id="add_to_basket"
                appButton="large"
                [disabled]="
                  !resultMatrix[selectedOutbound.journeyHash][selectedInbound.journeyHash][
                    selectedClass
                  ]?.out ||
                  !resultMatrix[selectedOutbound.journeyHash][selectedInbound.journeyHash][
                    selectedClass
                  ]?.in
                "
                (click)="closeAndAddToBasket()"
                i18n="@@cffAddToBasket"
              >
                Add to Basket
              </div>
            </div>
          </div>
        }
      </div>
    </ng-container>
    @if (loading) {
      <div class="preload loading-screen-container">
        <div class="loading-screen-box">
          <app-loading-spinner size="sm" />
          <span class="loading-screen-text" i18n="@@cffLoading">Loading...</span>
        </div>
      </div>
    }
  </div>
</div>
